export default __webpack_public_path__ + "static/media/flag-honduras.2ec73007.svg";